import './platform/bootstrap'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store'
import './index.css'
import AppRoutes from './routes'
import { ThemeProvider } from '@mui/material/styles'
import { gbTheme } from './styles/themes'
import reportWebVitals from './reportWebVitals'
import ErrorBoundary from './components/ErrorBoundary'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ErrorBoundary>
          <ThemeProvider theme={gbTheme}>
            <AppRoutes />
          </ThemeProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
)

reportWebVitals()
